import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {NgForm} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import { Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {FilterService} from "../../../shared/services/filter.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute, Router} from "@angular/router";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {FileManager} from "../../../shared/interface/file-manager";
import {FileManagerService} from "../../../shared/services/file-manager.service";
import {AddCatalogDialogComponent} from "../add-catalog-dialog/add-catalog-dialog.component";
import {AddFileDialogComponent} from "../add-file-dialog/add-file-dialog.component";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {srcFileManager} from "../../../../environments/environment";
import {Profile} from "../../../shared/interface/profile";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";

@Component({
  selector: 'app-file-manager-list',
  templateUrl: './file-manager-list.component.html',
  styleUrls: ['./file-manager-list.component.scss']
})
export class FileManagerListComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  totalData = 0;
  displayedColumns: string[] = [ 'img', 'fileName',  'typ', 'tag', 'cratedAt', 'createdBy', 'download'];
  fileManager: FileManager[] = [];
  userPermissions: ReplaySubject<UserPermissions>;
  userPermissionss: UserPermissions;
  sortBy = 'uuid';
  sortOrder = 'desc';
  idValue: string = null;
  initialFilters: any;
  profile: Profile;
  readonly  srcFileManager = srcFileManager;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private dialog: MatDialog,
    private fileManagerService: FileManagerService,
    private auth: AuthService,
    private store: Store<StoreRootState>,
    private filterService: FilterService,
    private snack: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });

    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissionss = userPermissions;
        if (this.userPermissionss.file_manager.admin_root) {
          this.displayedColumns = [ 'img', 'fileName',  'typ', 'public', 'tag', 'cratedAt', 'createdBy', 'download'];
        }
      });

    this.fileManagerService.getFileManagerListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<FileManager>) => {
          this.fileManager = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  ngOnInit(): void {
    this.activatedRoute.params

      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        if (params.id) {
          this.idValue = params.id;
          this.filter();

        }
      });
    this.parseFilters();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }


  ngAfterViewInit(): void {
    this.resetFilters();
    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.loadListData();
      });

    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.loadListData();
    });
  }

  loadListData(): void {
    this.fileManagerService.loadList(this.buildFilters(),
      this.paginator?.pageIndex, this.paginator?.pageSize,
      {
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      }
    );

  }

  filter(): void {
    this.loadListData();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({}, filters);
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    filters.catalogId = this.idValue;

    return filters;
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.loadListData();
  }

  addCatalog(): void {
    const dialogRef = this.dialog.open(AddCatalogDialogComponent, {
      width: '50vw',
      maxHeight: '90vh',
      data: {
        catalogLocation: this.idValue,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.loadListData();
    });
  }

  addFile(): void {
    const dialogRef = this.dialog.open(AddFileDialogComponent, {
      width: '50vw',
      maxHeight: '90vh',
      data: {
        catalogLocation: this.idValue,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.loadListData();
    });
  }

  editFile(file: FileManager): void {
    const dialogRef = this.dialog.open(AddFileDialogComponent, {
      width: '50vw',
      maxHeight: '90vh',
      data: {
        catalogLocation: this.idValue,
          file,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.loadListData();
    });
  }


  editCatalog(catalog: FileManager): void {
    const dialogRef = this.dialog.open(AddCatalogDialogComponent, {
      width: '50vw',
      maxHeight: '90vh',
      data: {
        catalogLocation: this.idValue,
        catalog,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.loadListData();
    });
  }

  back(): void {
    window.history.back();
  }

  download(uuid: string): void {
    this.fileManagerService.downloadFile(uuid);
  }

  deleteFile(uuid: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć plik ?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fileManagerService.deleteFile(uuid)
          .subscribe({
            next: () => {
              this.snack.open('Pomyślnie usunięto plik', '', {duration: 2000});
              this.loadListData();
            },
            error: (response: HttpErrorResponse) => {
              this.snack.open(response.error.error.text, response.status.toString(), {duration: 5000});
            }
          });
      }
    });
  }

  deleteCatalog(uuid: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć katalog ?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fileManagerService.deleteCatalog(uuid)
          .subscribe({
            next: () => {
              this.snack.open('Pomyślnie usunięto katalog', '', {duration: 2000});
              this.loadListData();
            },
            error: (response: HttpErrorResponse) => {
              // if (response.status.toString() === '422' )
              // {
                this.snack.open('W folderze znajdują się pliki innych użytkowników. Aby usunąć folder pliki muszą zostać usunięte przez uprawnionych użytkowników. ', response.status.toString(), {duration: 5000});

              // } else {
              //   this.snack.open(response.error.error.text, response.status.toString(), {duration: 5000});
              // }
            }
          });
      }
    });
  }

  getLink(fileManager: FileManager): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.srcFileManager.production + fileManager.fileLocation;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snack.open('Skopiowano do schowka link' , '', {duration: 2000});
  }
  getImg(fileManager: FileManager): string {
    return  this.srcFileManager.production + fileManager.folderIcon;
  }

  drop(event: CdkDragDrop<any[]>) {
    const pageSize = this.paginator.pageSize;
    const pageIndex = this.paginator.pageIndex;

    moveItemInArray(this.fileManager, event.previousIndex, event.currentIndex);
    this.fileManager = [...this.fileManager];


    const updatedItems = this.fileManager.map((item, index) => {
      return {
        uuid: item.uuid,
        newOrder: (pageIndex * pageSize) + index
      };
    });

    this.fileManagerService.updateOrder(updatedItems).subscribe();
  }

}
